import { render } from "./ForgotPasswordModel.vue?vue&type=template&id=5e0aa52a"
import script from "./ForgotPasswordModel.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__